import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Search, BookmarkCheck } from "lucide-react";
import { useUser } from "../context/UserContext";
import { STEADFAST_LOGO, COMPANY_NAME } from "../lib/brand";
import { Button } from "./ui/button";

export default function AppHeader({ onOpenSearch, onOpenBookmarks }) {
  const { theme, toggleTheme, user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/home";

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-between h-16">
        {/* Top-left Steadfast logo */}
        <Link
          to={user ? "/home" : "/"}
          className="flex items-center gap-3 group"
          data-testid="header-logo-left"
        >
          <img
            src={STEADFAST_LOGO}
            alt="Steadfast IT Consulting"
            className="h-9 w-auto object-contain"
          />
        </Link>

        {/* Center controls */}
        <div className="flex items-center gap-1 sm:gap-2">
          {!isHome && user && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/home")}
              data-testid="nav-home-btn"
              className="rounded-full gap-2"
            >
              <Home className="h-4 w-4" />
              <span className="hidden sm:inline">Home</span>
            </Button>
          )}
          {onOpenSearch && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onOpenSearch}
              data-testid="open-search-btn"
              className="rounded-full gap-2"
            >
              <Search className="h-4 w-4" />
              <span className="hidden sm:inline">Search</span>
            </Button>
          )}
          {onOpenBookmarks && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onOpenBookmarks}
              data-testid="open-bookmarks-btn"
              className="rounded-full gap-2"
            >
              <BookmarkCheck className="h-4 w-4" />
              <span className="hidden sm:inline">Bookmarks</span>
            </Button>
          )}

        </div>

        {/* Top-right Steadfast logo */}
        <Link
          to={user ? "/home" : "/"}
          className="flex items-center gap-3"
          data-testid="header-logo-right"
        >
          <div className="hidden sm:flex flex-col leading-tight text-right">
            <span className="text-xs uppercase tracking-[0.22em] text-muted-foreground">Learning Portal</span>
            <span className="text-sm font-medium -mt-0.5">{COMPANY_NAME}</span>
          </div>
          <img
            src={STEADFAST_LOGO}
            alt="Steadfast IT Consulting"
            className="h-9 w-auto object-contain"
          />
        </Link>
      </div>
    </header>
  );
}
